/**
 * What to tell someone when ending a membership is refused.
 *
 * The database refuses a removal that is not a handover when the member still
 * holds more than 250 Account owner roles (it would close them one by one in a
 * single transaction). Nothing is changed. That refusal gets its own message
 * with the remedy; every other failure keeps its own text.
 */
export const ACCOUNT_OWNER_ROLE_LIMIT_MARKER = 'account_owner_membership_close_limit_exceeded';
export const ACCOUNT_OWNER_ROLE_LIMIT_CODE = 'account_owner_roles_handover_required';

export const ACCOUNT_OWNER_ROLE_LIMIT_MESSAGE =
  'They still hold more than 250 Account owner roles, so nothing was changed. ' +
  'Hand their Accounts over to a teammate first, then try again.';

function textOf(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

/** True only for the Account owner role bound, however the error arrives. */
export function isAccountOwnerRoleLimitError(error: unknown): boolean {
  if (typeof error === 'string') return error.includes(ACCOUNT_OWNER_ROLE_LIMIT_MARKER);
  if (typeof error !== 'object' || error === null) return false;
  const record = error as Record<string, unknown>;
  if (record.error_code === ACCOUNT_OWNER_ROLE_LIMIT_CODE) return true;
  return [record.message, record.details, record.hint, record.error]
    .some((part) => textOf(part).includes(ACCOUNT_OWNER_ROLE_LIMIT_MARKER));
}

export function memberRemovalErrorMessage(error: unknown, fallback: string): string {
  if (isAccountOwnerRoleLimitError(error)) return ACCOUNT_OWNER_ROLE_LIMIT_MESSAGE;
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
